import { create } from "zustand";

const usePlayVideo = create((set) => ({
  isReady: false,
  id: null,
  onReady: (id) => set({ isReady: true }),
  isActive: false,
  isPlaying: false,
  isMuted: true,
  onPlay: (id) => set({isReady:true, isPlaying: true, isActive: true, isMuted: false }),
  onPause: (id) => set({ isPlaying: false, id:id }),

  onMute: (id) => set({ isMuted: true }),
  onUnMute: (id) => set({ isMuted: false }),

  // source: "https://www.youtube.com/watch?v=OumLgYZE-y4",
  // source: "https://www.youtube.com/embed/wCqcJU1YpKk?start=13&end=110"
  // setSource: (newSource) => set({source: newSource}),
}))


export default usePlayVideo;